import { IMinerLocationProps } from "./MinerLocation.props";
import cn from "classnames";
import styles from "./MinerLocation.module.scss";
import { useMinerLocationControl } from "./useMinerLocationControl";
import ColoredChanges from "../ColoredChanges/ColoredChanges";

export default function MinerLocation({ ...props }: IMinerLocationProps) {
  const { children } = props;
  const control = useMinerLocationControl(props);
  return (
    <div
      className={cn(styles.wrapper, props.className, {
        [styles.link]: control.canClick,
      })}
      onClick={control.canClick ? control.goToMiner : undefined}
    >
      <ColoredChanges>{children}</ColoredChanges>
    </div>
  );
}
